import './Button.less';
import React, {forwardRef} from 'react';
import Icon from '../icon/Icon';


export default forwardRef(Button);

const RefTag = forwardRef(Tag);

function Button({
    type = 'button', // button, submit, link-button
    name,
    title,
    tooltip,
    onClick = () => {},
    appearance = 'solid-primary',
    size = 'medium', // small, medium, large
    disabled,
    viewOnly,
    icon,
    iconPosition = 'start', // start, end
    href,
    linkTarget,
}, ref) {

    const iconComponent = <span className="ic-holder">
        {
            'string' === typeof icon
                ? <Icon name={icon}/>
                : icon
        }
    </span>;

    const handleClick = (ev) => {
        if (viewOnly) {
            ev.preventDefault();
            return;
        }

        onClick(ev);
    };

    return <RefTag
        ref={ref}
        type={type}
        className={
            `button-component button appearance-${appearance} size-${size}`
            + (name ? ` ${name}-button` : '')
            + (disabled ? ' disabled' : '')
            + (viewOnly ? ' view-only' : '')
        }
        onClick={ev => disabled || handleClick(ev)}
        aria-label={tooltip}
        href={href}
        target={linkTarget}
    >
        {
            icon &&
            iconPosition === 'start' &&
            iconComponent
        }
        <span className="text">{title}</span>
        {
            icon &&
            iconPosition === 'end' &&
            iconComponent
        }
    </RefTag>;
}

function Tag(props, ref) {
    if (props.type === 'link-button') {
        return <a {...props} ref={ref}>{props.children}</a>;
    }

    return <button {...props} ref={ref}>{props.children}</button>;
}
